"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirm = exports.confirmTypes = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const rebass_1 = require("rebass");
const emotion_theming_1 = require("emotion-theming");
const Modal_1 = __importDefault(require("../Modal"));
const theme_1 = require("../../StyleProvider/theme");
const Button_1 = require("../Button");
var confirmTypes;
(function (confirmTypes) {
    confirmTypes["default"] = "default";
    confirmTypes["danger"] = "danger";
    confirmTypes["warning"] = "warning";
})(confirmTypes = exports.confirmTypes || (exports.confirmTypes = {}));
const [modalRoot] = document.getElementsByTagName("body");
const ConfirmModal = function ({ title, message, actions, type, width, }) {
    return (react_1.default.createElement(Modal_1.default, { actions: actions, visible: true, width: width, title: react_1.default.createElement(rebass_1.Text, { color: {
                [confirmTypes.default]: "#111",
                [confirmTypes.danger]: theme_1.COLORS.DANGER,
                [confirmTypes.warning]: theme_1.COLORS.WARNING,
            }[type] }, title) },
        react_1.default.createElement(rebass_1.Box, { p: 3 },
            react_1.default.createElement(rebass_1.Text, null, message))));
};
exports.default = ConfirmModal;
function confirm({ title, message, onOk, onCancel, type = confirmTypes.default, primaryButton, actions, width = 300, }) {
    const elm = document.createElement("div");
    modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.appendChild(elm);
    const onClick = (action) => {
        react_dom_1.default.unmountComponentAtNode(elm);
        modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.removeChild(elm);
        if (action === "ok") {
            onOk && onOk();
        }
        else {
            onCancel && onCancel();
        }
    };
    react_dom_1.default.render(react_1.default.createElement(emotion_theming_1.ThemeProvider, { theme: theme_1.themeDefault },
        react_1.default.createElement(ConfirmModal, { type: type, title: title, message: message, width: width, actions: actions
                ? actions
                : [
                    {
                        title: primaryButton || "OK",
                        onClick: () => onClick("ok"),
                        variant: {
                            [confirmTypes.default]: Button_1.ButtonVariants.dark,
                            [confirmTypes.danger]: Button_1.ButtonVariants.danger,
                            [confirmTypes.warning]: Button_1.ButtonVariants.warning,
                        }[type],
                    },
                    {
                        title: "Cancel",
                        onClick: () => onClick("cancel"),
                        variant: Button_1.ButtonVariants.outline,
                    },
                ] })), elm);
    const close = () => onClick("cancel");
    return { close };
}
exports.confirm = confirm;
//# sourceMappingURL=index.js.map